var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalAttendanceCourier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.5 22.7653V18.5H29.5V22.7653C29.5 25.9401 29.5 27.5275 28.5237 28.5137C27.5474 29.5 25.976 29.5 22.8333 29.5H21.1667C18.024 29.5 16.4526 29.5 15.4763 28.5137C14.5 27.5275 14.5 25.9401 14.5 22.7653Z",
    fill: "#6C27FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22.7653V18.5H29.5V22.7653C29.5 25.9401 29.5 27.5275 28.5237 28.5137C27.5474 29.5 25.976 29.5 22.8333 29.5H21.1667C18.024 29.5 16.4526 29.5 15.4763 28.5137C14.5 27.5275 14.5 25.9401 14.5 22.7653Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.5L15.2211 16.9615C15.7804 15.7684 16.0601 15.1718 16.6269 14.8359C17.1938 14.5 17.9208 14.5 19.375 14.5H24.625C26.0792 14.5 26.8062 14.5 27.3731 14.8359C27.9399 15.1718 28.2196 15.7684 28.7788 16.9615L29.5 18.5",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 21.5H23.5",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAttendanceCourier);
export default __webpack_public_path__ + "static/media/total-attendance-courier.dd8b9d8451f7a2e78097a625fd7c4d56.svg";
export { ForwardRef as ReactComponent };